import { getPublicRuntimeConfig } from '@/utils/configs';
import KeycloakService from './keycloakService';
import axios from 'axios';
import { UseStoreNews } from '@/store/newsStore';
import { TypeNotification, useGlobalStore } from '@/store/globalStore';
// @ts-ignore
import SrhUiI18nService from 'srh-ui/dist/services/i18n';
import { HTTPMethods, callApi } from '@/utils/api';
import { getApiUrl } from '@/utils/url';

export default {
  async loadNews(categorie: number) {
    const i18n = new SrhUiI18nService();
    const { t } = i18n.getI18nInstance().global;

    const globalStore = useGlobalStore();

    try {
      await KeycloakService.CallUpdate().then(async () => {
        const newsStore = UseStoreNews();
        const config = {
          'Content-Type': 'application/json',
        };

        const newsData = {
          category: categorie,
          skip: 5,
        };

        await callApi({
          path: `${getApiUrl()}/srh4u/api/news`,
          method: HTTPMethods.POST,
          body: newsData,
          options: config,
          errorMessage: '',
          successCallback: (result: any) => {
            newsStore.clearNews();
            result.news.forEach(async (element: any) => {
              await newsStore.setNews(element);
            });
          },
        });
      });
    } catch (e: any) {
      if (e?.statusCode !== 403) {
        globalStore.showNotification(
          TypeNotification.ERROR,
          t('errors.unknown'),
          t('errors.title')
        );
      }
    }
  },
};
